import { Link } from "react-router-dom";

import { analytics } from "@/analytics";
import { Button } from "@/ui/components";
import { ConferencesIcon } from "@/ui/icons";

const DashboardButtons = () => {
  return (
    <div className="flex m-2 lg:hidden">
      <Link
        to="/board/conferences"
        onClick={() =>
          analytics.track("Navigation Clicked", {
            item: "Conferences",
            destination: "/board/conferences",
            location: "dashboard",
          })
        }
        className="flex mx-auto"
      >
        <Button variant={"default"}>
          <img
            src={ConferencesIcon.src}
            className="img-white aspect-square w-6"
            alt="Conferences"
          />
          Conferences &rarr;
        </Button>
      </Link>
    </div>
  );
};

export default DashboardButtons;
